module.exports = __webpack_public_path__ + "img/logo.754354bc.png";